import React from 'react';
import { UnsubscribeView } from '@shared/ui/unsubscribe/UnsubscribeView';
import { MainLayout } from '../layouts';

/** Email unsubscribe (/unsubscribe?token=...): the shared view in this app's frame. Public: the token identifies the customer. */
const UnsubscribePage: React.FC = () => (
  <MainLayout>
    <UnsubscribeView />
  </MainLayout>
);

export default UnsubscribePage;
